// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3tQNB","label":"style_label__15lXa","divider":"style_divider__1nTiY"};